import React from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Loader2 } from 'lucide-react';
import { EmptyState } from './shared';

export const LegalTermsSection = ({ legalTerms, setLegalTerms, onSave, saving }) => {
  if (!legalTerms) return <EmptyState message="Kunde inte ladda användarvillkor" />;

  return (
    <div className="space-y-6" data-testid="admin-legal-terms">
      <p className="text-sm text-gray-600 max-w-3xl">
        Texterna publiceras på egna sidor (samma princip som integritetspolicy):{' '}
        <strong>/anvandarvillkor-kund</strong> respektive <strong>/anvandarvillkor-butik</strong>.
        Vid registrering länkar formulären hit så användaren kan läsa fullständigt dokument innan godkännande.
      </p>

      <div className="bg-white rounded-lg shadow-sm p-6 space-y-3">
        <Label htmlFor="consumer-terms" className="text-base font-bold text-[#0F172A]">
          Användarvillkor — kunder (konsumenter)
        </Label>
        <textarea
          id="consumer-terms"
          className="w-full min-h-[220px] rounded-md border border-gray-200 p-3 text-sm font-mono leading-relaxed focus:outline-none focus:ring-2 focus:ring-[#003B73]/30"
          value={legalTerms.consumer_terms || ''}
          onChange={(e) => setLegalTerms({ ...legalTerms, consumer_terms: e.target.value })}
        />
        {legalTerms.consumer_terms_updated_at && (
          <p className="text-xs text-gray-400">Senast uppdaterad: {legalTerms.consumer_terms_updated_at}</p>
        )}
      </div>

      <div className="bg-white rounded-lg shadow-sm p-6 space-y-3">
        <Label htmlFor="store-terms" className="text-base font-bold text-[#0F172A]">
          Användarvillkor — butiker
        </Label>
        <textarea
          id="store-terms"
          className="w-full min-h-[220px] rounded-md border border-gray-200 p-3 text-sm font-mono leading-relaxed focus:outline-none focus:ring-2 focus:ring-[#003B73]/30"
          value={legalTerms.store_terms || ''}
          onChange={(e) => setLegalTerms({ ...legalTerms, store_terms: e.target.value })}
        />
        {legalTerms.store_terms_updated_at && (
          <p className="text-xs text-gray-400">Senast uppdaterad: {legalTerms.store_terms_updated_at}</p>
        )}
      </div>

      <Button className="bg-[#003B73]" onClick={onSave} disabled={saving}>
        {saving && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
        Spara användarvillkor
      </Button>
    </div>
  );
};
